import React from 'react';
import { Box, CircularProgress, Container } from '@mui/material';
import { useAuth } from '../hooks/useAuth';
import { AuthContext } from '../context/AuthContext';

/**
 * Componente wrapper che protegge l'app richiedendo autenticazione
 * Verificherà il cookie di Supabase SSO prima di renderizzare i children
 * Fornisce il username tramite Context
 */
export const AuthGuard = ({ children }) => {
  const { isAuthenticated, loading, username, user } = useAuth();

  // Mostra loading mentre controlla l'autenticazione
  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        bgcolor="#f5f5f5"
      >
        <Container maxWidth="sm">
          <Box textAlign="center">
            <CircularProgress size={40} />
            <p>Verifica dell'autenticazione in corso...</p>
          </Box>
        </Container>
      </Box>
    );
  }

  // Se non autenticato, il redirect avviene già nell'useAuth hook
  // Quindi qui renderizziamo solo se autenticato
  if (!isAuthenticated) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        bgcolor="#f5f5f5"
      >
        <Container maxWidth="sm">
          <Box textAlign="center">
            <p>Reindirizzamento al login...</p>
          </Box>
        </Container>
      </Box>
    );
  }

  // Renderizza i children se autenticato, fornendo il Context
  return (
    <AuthContext.Provider value={{ isAuthenticated, loading, username, user }}>
      {children}
    </AuthContext.Provider>
  );
};
